export const extractFileName = (url, fallback = "Unnamed File") => {
  try {
    const parts = url.split("/");
    return parts[parts.length - 1].split("?")[0]; // remove query params
  } catch {
    return fallback;
  }
};
